module.exports = __webpack_public_path__ + "img/new7.be470b75.jpg";